export const ORDER_FORM_OPTIONS = {
  bypassRequiredQuestions: false,
  readOnly: false,
  showOfficeUseQuestions: true,
};

export const FILE_UPLOAD_URL = '/_ajax/v1/marketplace/file/upload';
